import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { Button } from 'components/form/Button';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { requireTwoFactorAuthentication } from 'actions/twofactor.actions';

const CardActivationModule = props => {
  const { eventHandler, history, modulePosition, dispatch } = props;

  const moduleName = 'Reissue - Activate Card';

  const onClickCta = () => {
    eventHandler(CLICK, {
      'Click Type': 'Activate',
      'Module Name': moduleName,
    });

    dispatch(
      requireTwoFactorAuthentication(history, history.location, {
        requireEnrollment: true,
        isCashEnroll: true,
      }),
    ).then(() => {
      history.push('/cash/cardActivation/landing');
    });
  };

  const seenPixel = useSeenModulePixel(
    getViewModuleTrackingAttributes({
      moduleName: moduleName,
      modulePosition: modulePosition,
    }),
  );

  return (
    <>
      {seenPixel}
      <FlexContainer column className="m-margLR16">
        <FlexContainer
          alignItemsCenter
          className="bgBlue015 pad16 format100 margT20 margB36 borderRadius4"
        >
          <FlexContainer column className="format80 m-format65">
            <Label type="Subtitle-2" className="margB8">
              🚚 Your new card is on its way
            </Label>
            <Label type="Body-2">
              Activate your new debit card when you get it to continue spending
            </Label>
          </FlexContainer>
          <FlexContainer
            alignItemsCenter
            justifyEnd
            className="format20 m-flex-column m-format35"
          >
            <Label className="format100 m-flex-ord-2">
              <Button mrphType="primary" fullWidth onClick={onClickCta}>
                Activate
              </Button>
            </Label>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    </>
  );
};

export default CardActivationModule;
